import { forEach } from 'lodash';
import { PaginateListMore } from '../../../common/types/common-types';
import { Dispatch } from 'react';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import { CandidateInteractionReportListParams } from '../types/CandidateReportInteractionTypes';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;

const formatDataFilters = (params: CandidateInteractionReportListParams) => {
  let data: any = {
    dataFilters: [],
    page: params.page,
    limit: params.limit,
  };
  forEach(params, (param, key) => {
    if (param) {
      switch (key) {
        case 'requestedDateFrom':
          data.dataFilters.push({
            name: 'createdAt',
            value: param,
            type: 'Date',
            operator: 'gt',
          });
          break;
        case 'requestedDateTo':
          data.dataFilters.push({
            name: 'createdAt',
            value: param,
            type: 'Date',
            operator: 'lt',
          });
          break;
        case 'agentCode':
          data.dataFilters.push({
            name: 'agentCode',
            value: param,
            type: 'string',
            operator: 'search',
          });
          break;

        case 'unitCode':
          data.dataFilters.push({
            name: 'unitCode',
            value: param,
            type: 'string',
            operator: 'eq',
          });
          break;

        case 'branchCode':
          data.dataFilters.push({
            name: 'branchCode',
            value: param,
            type: 'string',
            operator: 'eq',
          });
          break;

        case 'officeCode':
          data.dataFilters.push({
            name: 'officeCode',
            value: param,
            type: 'string',
            operator: 'eq',
          });
          break;

        case 'candidateType':
          data.dataFilters.push({
            name: 'candidateType',
            value: param,
            type: 'string',
            operator: 'eq',
          });
          break;
      }
    }
  });
  return data;
};

export const fetchCandidateInteractionReportDownload = (
  params: CandidateInteractionReportListParams,
  dispatch?: Dispatch<any>,
): void => {
  const uri = `${ADMIN_URL}/report/candidate/interaction/export`;
  const data = formatDataFilters(params);

  apiClient
    .post<Blob>(uri, data, { responseType: 'text' })
    .then((response: any) => {
      const url = window.URL.createObjectURL(new Blob(['\uFEFF' + response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report-candidate-interaction' + new Date().toISOString() + '.csv');
      document.body.appendChild(link);
      link.click();
    })
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCandidateInteractionReport = async (
  params: CandidateInteractionReportListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<any>> => {
  const uri = `${ADMIN_URL}/report/candidate/interaction`;
  const data = formatDataFilters(params);

  return apiClient
    .post<PaginateListMore<any>>(uri, data)
    .then((response: any) => {
      return response.data;
    })
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};
